import { useContext } from 'react';
import { EnvironmentContext } from '@context/environment_context';

export const useEnvironmentContext = () => useContext(EnvironmentContext);
